// import {router} from 'vue'

export default {
  methods: {
    initShare(taskName ='',descs ='') {
      taskName = taskName || "快速了解感控工作间";
      descs = descs || "因为爱, 所以感控";
      let url = location.href
      console.log(url, "分享链接");
      this.commom.weiXinReady(3, descs, taskName, "", "", "", () => {}, url);
    },
    initIndexShare() {
      console.log('首頁分享');
      let descs = '因为爱, 所以感控';
      let taskName = '快速了解感控工作间';
      console.log('666走....');
      this.commom.weiXinReady(3, descs, taskName, "", "", "", () => {}, location.href.split('#')[0]);
    },
    // 打电话
    // 打电话
    callPhone(phone ='') {
      window.location.href = `tel://${phone}`
    },
    // 判断设置
    whatDevice() {
      let ua = navigator.userAgent.toLowerCase();
      // Android终端
      // let isAndroid =ua.indexOf('Android') > -1 || ua.indexOf('Adr') > -1;
      // Ios终端
      // let isiOS = !!ua.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
      let isAndroid = /android /.test(ua)
      let isiOS =/iphone/.test(ua)
      if(isAndroid) {
        this.deviceType = 1
      }else if (isiOS) {
        this.deviceType = 0
      }
      console.log(ua,'浏览器头....')
      console.log(isAndroid,'是安卓吗....')
      console.log(isiOS,'是ios吗....')
    },
    // 判断是微信浏览器吗
    isWeixinBrowser() {
      return (/micromessenger/.test(ua)) ? true : false;
    },
    // 下载感控工作间app
    goDownApp() {
      location.href = 'http://studio.gkgzj.com/download/deyagk.html'
    },
    // 默认置顶
    goDefaultTop() {
      // document.body.scrollTop = 0
      // document.documentElement.scrollTop = 0
    },
    // 去案例详情
    goCaseDetailGlobal(id ='') {
      if(id) {
        // router.push({
        //   path: "/detail/caseDetail",
        //   query: {
        //     id: id,
        //   },
        // });
      } else {
        location.href = 'https://mp.weixin.qq.com/s/0uvW5cJpcdjt3I85YuTRqA'
      }
      // window.open('https://mp.weixin.qq.com/s/0uvW5cJpcdjt3I85YuTRqA')
    }
  }
}
